export default "__VITE_ASSET__BOj2745L__"